import {
	SERVER_GET_USER_PROFILE,
	SERVER_SET_USER_GROUP_ROLE,
	SERVER_UPDATE_USER_DATA,
	SERVER_UPDATE_USER_SETTING,
	SERVER_UPDATE_USER_PASSWORD,
	SERVER_RESET_SHOW_INFO_MODAL_FLAG,
	OPEN_INFO_MODAL
} from 'constants/ActionTypes';

export const getUserProfile = (authToken, userId) => {
	return { type: SERVER_GET_USER_PROFILE, payload: { authToken, userId } };
};

export const setUserGroupRole = (authToken, userId, groupId, roleId) => {
	return {
		type: SERVER_SET_USER_GROUP_ROLE,
		payload: { authToken, userId, groupId, roleId }
	};
};

export const updateUserData = (authToken, userId, updateData) => {
	return {
		type: SERVER_UPDATE_USER_DATA,
		payload: { authToken, userId, updateData }
	};
};

export const updateUserSettings = (userId, settings) => {
	return {
		type: SERVER_UPDATE_USER_SETTING,
		payload: { userId, ...settings }
	};
};

export const updateUserPassword = (passwordOld, passwordNew, userId) => {
	return {
		type: SERVER_UPDATE_USER_PASSWORD,
		payload: { passwordOld, passwordNew, userId }
	};
};

export const resetShowInfoModalFlag = () => {
	return {
		type: SERVER_RESET_SHOW_INFO_MODAL_FLAG
	};
};

export const openInfoModal = () => {
	return {
		type: OPEN_INFO_MODAL
	};
};

export const logModalAction = type => {
	return { type: 'server/v3_dialog_action', payload: { type } };
};



// WEBPACK FOOTER //
// ./actions/UserProfile.js